
const BRAND = {
    secondary: "#170f4f",
};

const LoadingScreen = () => {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            background: "#ffffff",
            fontFamily: "'DM Mono', monospace",
        }}>
            <div style={{
                display: "flex", alignItems: "center", gap: "6px",
                padding: "40px 0",
            }}>
                <span style={{
                    fontSize: "10px",
                    letterSpacing: "0.18em",
                    textTransform: "uppercase",
                    color: BRAND.secondary,
                }}>
                    Powered by
                </span>
                <img
                    src="/bolttech-logo.png"
                    alt="bolttech"
                    style={{ height: "18px" }}
                    onError={(e) => {
                        (e.target as HTMLImageElement).style.display = "none";
                        const fb = document.createElement("span");
                        fb.textContent = "bolttech";
                        fb.style.cssText = `color:${BRAND.secondary};font-size:11px;letter-spacing:0.1em;`;
                        (e.target as HTMLImageElement).parentElement?.appendChild(fb);
                    }}
                />
            </div>
        </div>
    );
};

export default LoadingScreen;